@if (shouldBeShown) {
  <div class="user-privacy-panel">
    <p class="user-privacy-panel__text">
      <a [routerLink]="['/privacy-policy']">{{'we_use_cookies' | translate}}</a>
      {{'gdpr_ensure_experience' | translate}}.
    </p>
    <button
      (click)="accept()"
      [matRippleCentered]="true"
      class="user-privacy-panel-btn"
      matRipple>
      got it
    </button>
  </div>
}
